import { IGestaoDeVisitasBody, IGestaoDeVisitasPonto, IGestaoDeVisitasResponse } from "../../../Interfaces/Vendas/GestaoDeVisitas/GestaoVisitasInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function GestaoDeVisitaServices <
    TResponseType extends IGestaoDeVisitasResponse | Blob
>

    (pagina: number, responseBody: IGestaoDeVisitasBody, ExportExcel: number) {
        return Service(
            Axios.post<TResponseType>(
                `/vendas/visitas/listarvisitas?PAGINA=${pagina}&exportExcel=${ExportExcel}`, responseBody,
                { responseType: ExportExcel ? "blob" : "json" }
            )
        );
    }

    export async function ListarPontosDeVendaServices() {
    return Service(
        Axios.get<Array<IGestaoDeVisitasPonto>>(
            `/vendas/visitas/listarpontosdevenda`
        )
    );
}